// Module
var code = " <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" class=\"hex-icon\"> <g transform=\"rotate(90 200 200)\"> <polygon fill=\"currentColor\" points=\"132.77 392 75.9 335.12 211.21 199.82 76.26 64.88 133.13 8 324.95 199.82 132.77 392\"/> </g> </svg>";
// Exports
module.exports = code;